import { Text } from 'blaze-ui/Text/Text'
import UhOh from 'components/AiErrorModal/UhOh'
import { BrandVisualAnalysis } from 'types'
import Styles from './BrandVisualAnalysisProcessingModal.module.scss'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import { useConnectedAccountCardProps } from 'components/IntegrationsModal/ManageIntegrationAccounts/hooks'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'

interface Props {
  failureReason: BrandVisualAnalysis['failure_reason']
  integration: ExternalIntegration
}

const Description = ({ failureReason, integration }: Props) => {
  const { onRefreshConnection } = useConnectedAccountCardProps(integration)

  if (failureReason === 'not_enough_content') {
    return <Text>It looks like there isn't enough content to analyze. Please try again with a different account.</Text>
  }

  if (failureReason === 'fb_invalid_oauth') {
    return (
      <Text>
        Failed to analyze your account. <br />
        Please&nbsp;
        <button onClick={() => onRefreshConnection()}>
          <Text>refresh the account connection</Text>
        </button>
        &nbsp;and try again.
      </Text>
    )
  }

  return <Text>Something went wrong. Please try again.</Text>
}

export const Failed = ({ failureReason, integration }: Props) => {
  const { closeModal } = useModals()

  return (
    <div className={Styles.failed}>
      <div />
      <div className={Styles.failedContent}>
        <UhOh />
        <Description failureReason={failureReason} integration={integration} />
      </div>
      <div className={Styles.buttonContainer}>
        <Button variant="tertiary" onPress={() => closeModal()} size="lg">
          Back
        </Button>
      </div>
    </div>
  )
}
